import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, toRefs } from 'vue';

import { marketService } from '@exchange/libs/market/service/src';
import { usePriceTicks } from '@exchange/libs/price-ticks/service/src';

import PriceTicksHistoryList from './PriceTicksHistoryList.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PriceTicksHistoryContainer',
  props: {
  marketId: { type: String, required: true },
  showTitle: { type: Boolean, default: true },
},
  setup(__props) {

const props = __props;

const { marketId } = toRefs(props);

const { getMarket, getMarketPrecision } = marketService;

const { priceTicks, priceTicksAreLoading } = usePriceTicks(marketId);

const market = computed(() => getMarket(marketId.value));
const marketPrecisions = computed(() => getMarketPrecision(market.value));

return (_ctx: any,_cache: any) => {
  const _component_ot_module_container = _resolveComponent("ot-module-container")!

  return (_openBlock(), _createBlock(_component_ot_module_container, {
    key: _unref(marketId),
    class: "price-ticks-history-container",
    loading: _unref(priceTicksAreLoading),
    title: __props.showTitle ? _ctx.$t('modules.marketHistory.title') : '',
    "with-bottom-padding": true
  }, {
    "main-content": _withCtx(() => [
      _createVNode(PriceTicksHistoryList, {
        "price-ticks": _unref(priceTicks),
        "market-id": _unref(marketId),
        "amount-precision": marketPrecisions.value.amount,
        "market-precision": marketPrecisions.value.market
      }, null, 8, ["price-ticks", "market-id", "amount-precision", "market-precision"])
    ]),
    _: 1
  }, 8, ["loading", "title"]))
}
}

})